<template>
  <div class="pageblock">
    <a-spin :spinning="isLoading">
      <div class="spin-content">
        <page-title
          v-if="hasTitle"
          :showExportBtn="showExportBtn"
          :config="config"
          :dataExport="dataExport"
          :exportName="exportName"
          :columns="columns"
          :title="title"
          :btnText="btnText"
          v-bind:btns="btns"
        />

        <slot></slot>
      </div>
    </a-spin>
  </div>
</template>

<script>
import PageTitle from '@/components/page/PageTitle';

export default {
  name: 'PageBlock',

  components: { PageTitle },

  props: {
    btnText: {
      type: String,
      default: '',
      require: true,
    },
    title: {
      type: [String, Boolean],
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showExportBtn: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => {},
    },
    dataExport: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    btns: {
      type: Array,
      require: false,
      default: () => {
        return [
          { label: 'Текущая страница XLSX', format: 'xlsx' },
          { label: 'Все данные CSV', format: 'csv' },
        ]
      },
    },
    exportName: {
      type: String,
      default: '',
      require: false
    }
  },

  computed: {
    hasTitle() {
      return this.title !== false;
    },
  },
};
</script>
